import { notification, Switch } from "antd";
import { Dispatch, SetStateAction, useState } from "react";

import {
  updateAdminPartner,
  updateAdminWallet,
  updateAdvancedFlag,
  updateAirportQrAllowed,
  updateQrOptionalAddressAllowed,
  updateGuestTripsEnabled,
  updateIsManualEntryAuthorizedFlag,
  updateSendWhatsappMessageFlag,
  updateShowLogo,
} from "../../../../services/adminApi";

export interface Props {
  adminId: number;
  switchValue: boolean;
  setIgnoreFetch: Dispatch<SetStateAction<boolean>>;
  switchType: string;
}

const AdminSwitch = ({
  adminId,
  switchValue,
  setIgnoreFetch,
  switchType,
}: Props) => {
  const [loading, setLoading] = useState(false);

  const onChange = async (value: boolean) => {
    setLoading(true);
    switch (switchType) {
      case "wallet":
        try {
          await updateAdminWallet(adminId, value);
        } catch (error) {
          notification.error({
            message: `Ha ocurrido un error al ${
              value ? "activar" : "desactivar"
            } el acceso a generar una cartera, intentelo más tarde.`,
            placement: "bottom",
            key: "global",
          });
        }
        break;
      case "airportQrAllowed":
        try {
          await updateAirportQrAllowed(adminId, value);
        } catch (error) {
          notification.error({
            message: `Ha ocurrido un error al ${
              value ? "activar" : "desactivar"
            } el acceso a generar qrs para aeropuertos, intentelo más tarde.`,
            placement: "bottom",
            key: "global",
          });
        }
        break;
      case "qrOptionalAddressAllowed":
        try {
          await updateQrOptionalAddressAllowed(adminId, value);
        } catch (error) {
          notification.error({
            message: `Ha ocurrido un error al ${
              value ? "activar" : "desactivar"
            } la dirección opcional en la generación de QRs, intentelo más tarde.`,
            placement: "bottom",
            key: "global",
          });
        }
        break;
      case "showLogo":
        try {
          await updateShowLogo(adminId, value);
        } catch (error) {
          notification.error({
            message: `Ha ocurrido un error al ${
              value ? "activar" : "desactivar"
            } el acceso para mostrar el logo, intentelo más tarde.`,
            placement: "bottom",
            key: "global",
          });
        }
        break;
      case "guestTripsEnabled":
        try {
          await updateGuestTripsEnabled(adminId, value);
        } catch (error) {
          notification.error({
            message: `Ha ocurrido un error al ${
              value ? "activar" : "desactivar"
            } los viajes de invitado, intentelo más tarde.`,
            placement: "bottom",
            key: "global",
          });
        }
        break;
      case "advanced":
        try {
          await updateAdvancedFlag(adminId, value);
        } catch (error) {
          notification.error({
            message: `Ha ocurrido un error al ${
              value ? "activar" : "desactivar"
            } la administración avanzada, intentelo más tarde.`,
            placement: "bottom",
            key: "global",
          });
        }
        break;
      case "partner":
        try {
          await updateAdminPartner(adminId, value);
        } catch (error) {
          notification.error({
            message: `Ha ocurrido un error al ${
              value ? "activar" : "desactivar"
            } el acceso a generar QR, intentelo más tarde.`,
            placement: "bottom",
            key: "global",
          });
        }
        break;
      case "coordinates":
        try {
          await updateIsManualEntryAuthorizedFlag(adminId, value);
        } catch (error) {
          notification.error({
            message: `Ha ocurrido un error al ${
              value ? "activar" : "desactivar"
            } la autorizacion para enviar coordenadas en viajes, intentelo más tarde.`,
            placement: "bottom",
            key: "global",
          });
        }
        break;
      case "sendWhatsappMessage":
        try {
          await updateSendWhatsappMessageFlag(adminId, value);
        } catch (error) {
          notification.error({
            message: `Ha ocurrido un error al ${
              value ? "activar" : "desactivar"
            } la autorizacion para enviar coordenadas en viajes, intentelo más tarde.`,
            placement: "bottom",
            key: "global",
          });
        }
        break;
    }
    setIgnoreFetch(false);
    setLoading(false);
  };

  return (
    <Switch
      loading={loading}
      defaultChecked={switchValue}
      onChange={onChange}
    />
  );
};

export default AdminSwitch;
